export default "__VITE_ASSET__ZpjvbKld__"